import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=e2f4e54e&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=e2f4e54e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f4e54e",
  null
  
)

export default component.exports